import type { TranslationKey } from 'src/shared/hooks/useTranslate';

enum CardTypes {
  DEFAULT = 'default',
  INACTIVE_FEATURE = 'inactiveFeature',
  DESIGN = 'design',
  RESET = 'reset',
  SHARE = 'share',
  SHOW_DESIGN = 'showDesign',
  INSPIRE_ME = 'inspireMe',
}

interface CardCopyType {
  cardType: CardTypes;
  title: TranslationKey | '';
  body?: TranslationKey | '';
  feature: string;
}

const TOOLBAR_HEIGHT = 96;
const LANDSCAPE_TOOLBAR_WIDTH = 89;
const LANDSCAPE_TOOLBAR_MENU_WIDTH = 380;
const LANDSCAPE_TOOLBAR_PADDING_FOR_LOGO = 76;

const TOOLBAR_BUTTON_SIDE_LENGTH = 64;
const DIVIDER_PIXEL_WIDTH = 1 + 16;

// 4 active menu items, 2 disabled menu items, a divider, version, and reset
const DEFAULT_TOOLBAR_MIN_LENGTH =
  TOOLBAR_BUTTON_SIDE_LENGTH * 8 + DIVIDER_PIXEL_WIDTH;

// 4 active menu items, a divider, version, and reset
const PARTNER_TOOLBAR_MIN_LENGTH =
  TOOLBAR_BUTTON_SIDE_LENGTH * 6 + DIVIDER_PIXEL_WIDTH;

// 4 active menu items, 2 disabled menu items
const GUEST_TOOLBAR_MIN_LENGTH = TOOLBAR_BUTTON_SIDE_LENGTH * 6;

// 4 active menu items
const PARTNER_GUEST_TOOLBAR_MIN_LENGTH = TOOLBAR_BUTTON_SIDE_LENGTH * 4;

const cardCopy: Record<string, CardCopyType> = {
  DEFAULT: {
    cardType: CardTypes.DEFAULT,
    title: '',
    body: '',
    feature: '',
  },
  DOOR: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.inactiveDoor.title',
    body: 'menu.inactiveDoor.body',
    feature: 'doors',
  },
  ACCENT: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.accent.title',
    body: 'menu.accent.body',
    feature: 'accents',
  },
  VERSION: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.version.title',
    body: 'menu.version.body',
    feature: 'versions',
  },
  RESET: {
    cardType: CardTypes.RESET,
    title: 'menu.reset.title',
    body: 'menu.reset.body',
    feature: 'reset',
  },
  TRIM: {
    cardType: CardTypes.DESIGN,
    title: 'menu.trim.title',
    feature: 'trim',
  },
  TEMPLATE: {
    cardType: CardTypes.DESIGN,
    title: 'menu.template.title',
    feature: 'roof',
  },
  WALL: {
    cardType: CardTypes.DESIGN,
    title: 'menu.wall.title',
    feature: 'walls',
  },
  ROOF: {
    cardType: CardTypes.DESIGN,
    title: 'menu.roof.title',
    feature: 'roof',
  },
  WINDOW: {
    cardType: CardTypes.DESIGN,
    title: 'menu.window.title',
    feature: 'windows',
  },
  INTERACTIVE_RENDERING_WALL: {
    cardType: CardTypes.DESIGN,
    title: 'menu.wall.title',
    feature: 'walls',
  },
  INTERACTIVE_RENDERING_ROOF: {
    cardType: CardTypes.DESIGN,
    title: 'menu.roof.title',
    feature: 'roof',
  },
  INTERACTIVE_RENDERING_TRIM: {
    cardType: CardTypes.DESIGN,
    title: 'menu.trim.title',
    feature: 'trim',
  },
  INTERACTIVE_RENDERING_HELP: {
    cardType: CardTypes.DESIGN,
    title: 'menu.interactiveRenderingHelpMenu.title',
    feature: 'help',
  },
  SHARE: {
    cardType: CardTypes.SHARE,
    title: 'menu.share.title',
    feature: 'share',
  },
  SHOW_DESIGN: {
    cardType: CardTypes.SHOW_DESIGN,
    title: 'menu.designConfigCard.title',
    feature: 'show_design',
  },
  INSPIRE_ME: {
    cardType: CardTypes.INSPIRE_ME,
    title: 'menu.inspireMe.title',
    feature: 'inspireMe',
  },
};

export {
  cardCopy,
  CardTypes,
  CardCopyType,
  TOOLBAR_HEIGHT,
  LANDSCAPE_TOOLBAR_WIDTH,
  LANDSCAPE_TOOLBAR_MENU_WIDTH,
  LANDSCAPE_TOOLBAR_PADDING_FOR_LOGO,
  TOOLBAR_BUTTON_SIDE_LENGTH,
  DEFAULT_TOOLBAR_MIN_LENGTH,
  GUEST_TOOLBAR_MIN_LENGTH,
  PARTNER_TOOLBAR_MIN_LENGTH,
  PARTNER_GUEST_TOOLBAR_MIN_LENGTH,
};
